<section class="bulk-coupon-edit-page">
  <app-admin-page-header title="Editar múltiplos cupons" subtitle="Os nomes dos cupons não podem ser alterados."></app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">{{ feedbackError }}</div>

  <form class="bulk-coupon-edit admin-surface" *ngIf="!isLoading && coupons.length" (ngSubmit)="submit()">
    <p>{{ coupons.length }} cupom(ns) selecionado(s). Campos com <strong>*</strong> possuem valores diferentes e serão preservados se não forem alterados.</p>

    <div class="bulk-coupon-edit__grid">
      <label class="bulk-coupon-edit__boolean">
        <span>Ativo</span>
        <span class="bulk-coupon-edit__tri-state">
          <input type="checkbox" [checked]="booleanValues.is_active === true" [indeterminate]="booleanValues.is_active === 'mixed'" (change)="onBooleanChange('is_active', $event)" />
          <span>{{ booleanValues.is_active === 'mixed' ? 'Valores diferentes' : booleanValues.is_active ? 'Ativo' : 'Inativo' }}</span>
        </span>
      </label>
      <label class="bulk-coupon-edit__boolean">
        <span>Uso único</span>
        <span class="bulk-coupon-edit__tri-state">
          <input type="checkbox" [checked]="booleanValues.one_time_use === true" [indeterminate]="booleanValues.one_time_use === 'mixed'" (change)="onBooleanChange('one_time_use', $event)" />
          <span>{{ booleanValues.one_time_use === 'mixed' ? 'Valores diferentes' : booleanValues.one_time_use ? 'Sim' : 'Não' }}</span>
        </span>
      </label>
      <label class="bulk-coupon-edit__boolean">
        <span>Exclusivo para trusted</span>
        <span class="bulk-coupon-edit__tri-state">
          <input type="checkbox" [checked]="booleanValues.trusted_only === true" [indeterminate]="booleanValues.trusted_only === 'mixed'" (change)="onBooleanChange('trusted_only', $event)" />
          <span>{{ booleanValues.trusted_only === 'mixed' ? 'Valores diferentes' : booleanValues.trusted_only ? 'Sim' : 'Não' }}</span>
        </span>
      </label>
      <label>
        <span>Máximo de usos</span>
        <input class="admin-input" type="number" min="0" [(ngModel)]="bulkEdit.coupons_max_usage" name="maxUsage" [placeholder]="hasDifferentValues.coupons_max_usage ? '*' : ''" (ngModelChange)="onValueChange('coupons_max_usage')" />
        <small *ngIf="hasDifferentValues.coupons_max_usage">* valores diferentes</small>
      </label>
      <label>
        <span>Conta vinculada</span>
        <input class="admin-input" type="number" min="1" [(ngModel)]="bulkEdit.account_id" name="accountId" [placeholder]="hasDifferentValues.account_id ? '*' : 'Vazio desvincula'" (ngModelChange)="onValueChange('account_id')" />
        <small *ngIf="hasDifferentValues.account_id">* valores diferentes</small>
      </label>
      <label>
        <span>Vencimento</span>
        <input class="admin-input" type="datetime-local" [(ngModel)]="bulkEdit.expiration_datetime" name="expiration" (ngModelChange)="onValueChange('expiration_datetime')" />
        <small *ngIf="hasDifferentValues.expiration_datetime">* valores diferentes</small>
      </label>
      <label>
        <span>Desconto em porcentagem</span>
        <input class="admin-input" type="number" min="1" [(ngModel)]="bulkEdit.percentage_discount" name="percentageDiscount" [placeholder]="hasDifferentValues.percentage_discount ? '*' : ''" (ngModelChange)="onDiscountChange('percentage_discount')" />
        <small *ngIf="hasDifferentValues.percentage_discount">* valores diferentes</small>
      </label>
      <label>
        <span>Desconto fixo</span>
        <input class="admin-input" type="number" min="1" [(ngModel)]="bulkEdit.fixed_discount" name="fixedDiscount" [placeholder]="hasDifferentValues.fixed_discount ? '*' : ''" (ngModelChange)="onDiscountChange('fixed_discount')" />
        <small *ngIf="hasDifferentValues.fixed_discount">* valores diferentes</small>
      </label>
    </div>

    <div class="bulk-coupon-edit__footer">
      <button type="button" class="admin-btn admin-btn--secondary" routerLink="/dashboard/cupons">Cancelar</button>
      <button type="submit" class="admin-btn admin-btn--primary" [disabled]="isSaving">{{ isSaving ? 'Salvando...' : 'Aplicar alterações' }}</button>
    </div>
  </form>
</section>
